import React from 'react';
import { Button as ShadcnButton, ButtonProps as ShadcnButtonProps } from '../ui/button';

// Map old variants to shadcn variants for backward compatibility
type LegacyVariant = 'primary' | 'secondary' | 'accent' | 'danger';
type ShadcnVariant = 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
type LegacySize = 'sm' | 'md' | 'lg';
type ShadcnSize = 'default' | 'sm' | 'lg' | 'icon';

const variantMap: Record<LegacyVariant, ShadcnVariant> = {
  primary: 'default',
  secondary: 'outline',
  accent: 'default',
  danger: 'destructive',
};

const sizeMap: Record<LegacySize, ShadcnSize> = {
  sm: 'sm',
  md: 'default',
  lg: 'lg',
};

export interface ButtonProps extends Omit<ShadcnButtonProps, 'variant' | 'size'> {
  variant?: LegacyVariant | ShadcnVariant;
  size?: LegacySize | ShadcnSize;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, size, ...props }, ref) => {
    // Map legacy variants to shadcn variants
    const shadcnVariant = variant && variant in variantMap 
      ? variantMap[variant as LegacyVariant] 
      : (variant as ShadcnVariant | undefined);
    
    // Map legacy sizes to shadcn sizes
    const shadcnSize = size && size in sizeMap
      ? sizeMap[size as LegacySize]
      : (size as ShadcnSize | undefined);

    return <ShadcnButton ref={ref} variant={shadcnVariant} size={shadcnSize} {...props} />;
  }
);
Button.displayName = 'Button';

